"use strict";

import angular from "angular";
import "../velotooler-ui/legacy-app-shim";
import app from "velotooler-app";

angular.bootstrap(document, [app.name, "legacy-app"], {
    strictDi: true
});
